

import { useCallback, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { carritoOItemXID, listadoCarritoXOp, listadoCarritoXUser, listadoItemsParaTrabajo, listadoMisItemsTrabajo, listadoTodosItemCarritos } from "../../../services";




export const useCarritoXID = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['itemxid', { id }], 
        queryFn: () => carritoOItemXID(id),
        enabled: !!id,
    });

    return { data, isLoading }
}



export const useItemsTodosCarritos = () => {
    const [termino, setTermino] = useState('');
    const [page, setPage] = useState(0);

    const chagePage = useCallback((num) => {
        setPage(num - 1);
    }, [])


    const chageTermino = useCallback((valor) => {
        setPage(0);
        setTermino(valor)
    }, [])


    const { data, isLoading } = useQuery({
        queryKey: ['todos-carritos', { page, termino }], 
        queryFn: () => listadoTodosItemCarritos({ page, termino }),
    });
    

    return { 
        page,
        termino,
        chagePage,
        chageTermino,
        data, isLoading 
    }
}





export const useItemsDisponiblesTrabajo = () => {
    const [termino, setTermino] = useState('');
    const [page, setPage] = useState(0);

    const chagePage = useCallback((num) => {
        setPage(num - 1);
    }, [])


    const chageTermino = useCallback((valor) => {
        setPage(0);
        setTermino(valor)
    }, [])


    const { data, isLoading } = useQuery({
        queryKey: ['disponibles-trabajo', { page, termino }], 
        queryFn: () => listadoItemsParaTrabajo({ page, termino }),
    });
    

    return { 
        page,
        termino,
        chagePage,
        chageTermino,
        data, isLoading 
    }
}



export const useMisItemsTrabajo = () => {
    const [termino, setTermino] = useState('');
    const [page, setPage] = useState(0);

    const chagePage = useCallback((num) => {
        setPage(num - 1);
    }, [])

    const chageTermino = useCallback((valor) => {
        setPage(0);
        setTermino(valor)
    }, [])


    const { data, isLoading } = useQuery({
        queryKey: ['misitems-trabajo', { page, termino }], 
        queryFn: () => listadoMisItemsTrabajo({ page, termino }),
    });
    
    return { 
        page,
        termino,
        chagePage,
        chageTermino,
        data, isLoading 
    }
}



export const useListadoCArritoXOp = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['carritoxop', { id }], 
        queryFn: () => listadoCarritoXOp(id),
        enabled: !!id,
    });
    
    return { data, isLoading }
}




export const useListCarritoXUser = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['carritoxuser', { id }], 
        queryFn: () => listadoCarritoXUser(id),
        enabled: !!id,
    });
    
    return { data, isLoading }
}
